import type { ParsedUrlQuery } from 'querystring';
import type { ReactNode } from 'react';
import type { PRODUCT_DETAIL_COLLAPSIBLE_KEY, PRODUCT_TABS_KEY } from '@product/ProductTabs/ProductTabsTypes';
import type { WidenMediaElement } from '@libs/widen-utils';

export type Nullable<T> = T | null;

export type Category = {
  key: string;
  parentKey?: string;
  name: string;
  path: string;
  alternates: Record<string, string>;
  aliases: Record<string, string> | null;
  children?: Category[];
};

export interface TechnicalData {
  description: string;
  value: string | boolean;
  icon?: Nullable<string>;
  mediaElement?: Nullable<WidenMediaElement>;
}

export interface ContentItem {
  key?: PRODUCT_TABS_KEY | PRODUCT_DETAIL_COLLAPSIBLE_KEY;
  title: string;
  content: ReactNode;
  alternativeContent?: ReactNode;
}

export interface CategoryPageParams extends ParsedUrlQuery {
  categoryL1: string;
  categoryL2: string;
  params?: string[];
}

// from next-seo/lib/types.d.ts - not exported unfortunately
export interface LanguageAlternate {
  hrefLang: string;
  href: string;
  L?: string;
}

export interface CableToolsPostMessage {
  action: string;
  url?: string;
}

export enum KeyboardKeyName {
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',

  // internet explorer uses different names than specified
  IE_ARROW_LEFT = 'Left',
  IE_ARROW_RIGHT = 'Right',
  IE_ARROW_UP = 'Up',
  IE_ARROW_DOWN = 'Down',
}

export interface NextI18NextConfig {
  fallbackNS: string;
  fallbackLng: Record<string, string[]>;
  localePath: string;
  i18n: I18NextConfig;
}

export interface I18NextConfig {
  localeDetection?: boolean;
  defaultLocale: string;
  locales: string[];
  domains?: I18NextDomain[];
}

export interface I18NextDomain {
  domain: string;
  defaultLocale: string;
  locales?: string[];
}
